import React from 'react';
import { Card, CardContent } from '@/app/_components/core/card';
import { SmartLink } from '@/app/_components/core/smart-link';
import { CardSectionElement } from '@/app/_components/shared/card-section/card-section.types';
import { cn } from '@/app/_lib/utils';

interface BenefitsCardProps {
  card: CardSectionElement;
  trackId?: string;
}

export function BenefitsCard({ card, trackId }: BenefitsCardProps) {

  const cardContent = (
    <CardContent className="flex h-full flex-col items-center justify-center gap-3 px-6 py-5">
      {card.icon && (
        <div className="flex size-12  items-center justify-center rounded-md border border-white bg-background">
          {/* eslint-disable-next-line @next/next/no-img-element -- small CMS card icon, no next/image benefit */}
          <img
            src={card.icon.url}
            alt={card.icon.altText ?? ''}
            width={28}
            height={28}
            // keep eager loading but opt out of React's automatic SSR
            // preloading so tiny icons don't compete with the LCP image
            fetchPriority="low"
            className="h-full max-h-7 w-auto max-w-7"
          />
        </div>
      )}
      {card.title && (
        <h3 className="mb-2 line-clamp-3 text-center text-h4/normal  font-extrabold wrap-anywhere">
          {card.title}
        </h3>
      )}
    </CardContent>
  );

  if (card.linkUrl) {
    return (
      <Card
        variant="elevated"
        className={cn('p-0 transition-shadow hover:shadow-lg')}
        asChild
      >
        <SmartLink
          href={card.linkUrl}
          target={card.linkTarget}
          download={card.download}
          data-track-id={trackId}
        >
          {cardContent}
        </SmartLink>
      </Card>
    );
  }

  return (
    <Card variant="elevated" className="p-0">
      {cardContent}
    </Card>
  );
}
